(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9705],{

/***/ 56410:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eventos/[slug]",
      function () {
        return __webpack_require__(51562);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EventBreadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/domain/Event/EventCategories.js


var defaultProps = {};
var propTypes = {
    categories: prop_types_default().arrayOf((prop_types_default()).object).isRequired
};
function EventCategories(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center space-x-4",
        children: categories.map(function(param) {
            var id = param.id, name = param.name;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-gray-900 leading-none whitespace-nowrap",
                children: name
            }, id);
        })
    });
};
EventCategories.defaultProps = defaultProps;
EventCategories.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/domain/Event/EventBreadcrumb.js





var EventBreadcrumbDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-gray-400",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "w-4 h-4 fill-current",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                clipRule: "evenodd"
            })
        })
    });
};
var EventBreadcrumb_defaultProps = {
    title: null,
    uri: null,
    showEventPage: false,
    categories: []
};
var EventBreadcrumb_propTypes = {
    title: (prop_types_default()).string,
    uri: (prop_types_default()).string,
    showEventPage: (prop_types_default()).bool,
    categories: prop_types_default().arrayOf((prop_types_default()).object)
};
function EventBreadcrumb(param) {
    var title = param.title, uri = param.uri, showEventPage = param.showEventPage, categories = param.categories;
    var hasCategory = categories && categories.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-x-1 max-w-full overflow-x-auto pb-4 md:pb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/eventos",
                className: "font-medium text-green-500",
                children: "Eventos"
            }),
            showEventPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventBreadcrumbDivider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: uri,
                        className: "font-medium text-green-500 whitespace-nowrap",
                        children: title
                    })
                ]
            }),
            hasCategory && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventBreadcrumbDivider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategories, {
                        categories: categories
                    })
                ]
            })
        ]
    });
};
EventBreadcrumb.defaultProps = EventBreadcrumb_defaultProps;
EventBreadcrumb.propTypes = EventBreadcrumb_propTypes;


/***/ }),

/***/ 51562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Event; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/domain/Event/EventBreadcrumb.js + 1 modules
var EventBreadcrumb = __webpack_require__(91516);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/domain/Event/EventDate.js


function EventDate(param) {
    var date = param.date;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "font-semibold text-gray-500",
        children: moment_default()(date).format("MMMM e, YYYY")
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventDatePastBagde.js

function EventDatePastBagde() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-200 text-gray-500 rounded inline-flex px-4 py-2 text-sm font-semibold",
        children: "Evento pasado"
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/isNotAPastEvent.js

function isNotAPastEvent(dates, publishDate) {
    var today = moment_default()();
    if (dates === null || dates === undefined) {
        if (publishDate) {
            return moment_default()(publishDate, "MM-DD-YYYY").isBefore(today) === false;
        }
        return true;
    }
    return dates.some(function(param) {
        var date = param.date, hour = param.hour;
        return moment_default()("".concat(date, " ").concat(hour), "MM-DD-YYYY H:m:s").isSameOrAfter(today);
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventDateInfo.js




function EventDateInfo(param) {
    var publishDate = param.publishDate, dates = param.dates;
    var showPastEventBadge = isNotAPastEvent(dates, publishDate) === false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center space-x-4 flex-1",
            children: [
                showPastEventBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventDatePastBagde, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventDate, {
                    date: publishDate
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventExcerpt.js

function EventExcerpt(param) {
    var excerpt = param.excerpt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: excerpt
        }
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventContent.js

function EventContent(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "prose lg:prose-lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventInfoPlace.js

function EventInfoPlace(param) {
    var place = param.place;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-x-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "w-4 h-4 fill-current text-gray-500",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                    clipRule: "evenodd"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-medium",
                children: place
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventInfoDates.js

function EventInfoDates(param) {
    var dates = param.dates;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: dates.map(function(param, index) {
            var date = param.date, hour = param.hour;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " flex items-center space-x-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-medium",
                        children: date
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 border-t-2 border-dashed border-gray-700"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-normal",
                        children: hour
                    })
                ]
            }, "event-date-".concat(index));
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventInfoWebsite.js

function EventInfoWebsite(param) {
    var website = param.website;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: website,
        className: "flex items-center justify-center space-x-2 bg-green-600 hover:bg-green-500 transition ease-in-out duration-300 rounded pl-2 pr-4 py-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "font-semibold text-lg",
            children: "M\xe1s informaci\xf3n"
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Event/EventPanelInfo.js




function EventPanelInfo(param) {
    var info = param.info;
    var hasPlace = (info === null || info === void 0 ? void 0 : info.place) !== null;
    var hasDates = (info === null || info === void 0 ? void 0 : info.dates) !== null;
    var hasWebsite = (info === null || info === void 0 ? void 0 : info.website) !== null;
    var hasContent = hasPlace || hasDates || hasWebsite;
    if (hasContent === false) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "rounded shadow-xl bg-gray-900 text-gray-100 p-6 space-y-6",
        children: [
            hasPlace && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInfoPlace, {
                place: info.place
            }),
            hasDates && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInfoDates, {
                dates: info.dates
            }),
            hasWebsite && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInfoWebsite, {
                website: info.website
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/domain/Event/EventPhotoGallery.js


function EventPhotoGallery(param) {
    var event = param.event, uri = param.uri;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "rounded-2xl shadow-xl bg-gray-900 p-6 flex flex-col space-y-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-gray-400 uppercase tracking-wide text-sm",
                        children: "Galer\xeda de fotos"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-white font-semibold text-xl",
                        children: "Visualiza las instant\xe1neas tomadas durante la realizaci\xf3n del evento"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                href: "".concat(uri, "/fotos"),
                className: "bg-gray-700 rounded-xl p-4 flex items-center space-x-4 transform transition ease-in-out duration-300 hover:-translate-y-1 hover:bg-gray-600 focus:outline-none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-10 h-10 rounded-full bg-green-600 text-white flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "w-6 h-6",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z",
                                clipRule: "evenodd"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "text-left text-base font-medium text-white leading-normal",
                            children: event
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/eventos/[slug]/index.js








var __N_SSG = true;
function Event(param) {
    var event = param.event, isNotAPastEvent = param.isNotAPastEvent;
    var ref, ref1;
    var hasExcerpt = !!event.excerpt && event.excerpt !== "";
    var hasGallery = !!((ref = event.gallery) === null || ref === void 0 ? void 0 : ref.images);
    var categories = ((ref1 = event.eventTypes) === null || ref1 === void 0 ? void 0 : ref1.nodes) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gradient-to-b from-white to-gray-100 pt-10 pb-12 lg:pb-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
            className: "space-y-4 lg:space-y-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventBreadcrumb/* default */.Z, {
                    categories: categories
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 lg:grid-cols-12 lg:gap-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:col-span-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-xl font-medium tracking-tight lg:text-4xl lg:font-bold",
                                        children: event.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventDateInfo, {
                                        publishDate: event.date,
                                        dates: event.info.dates
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col space-y-6",
                                        children: [
                                            hasExcerpt && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventExcerpt, {
                                                excerpt: event.excerpt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContent, {
                                                content: event.content
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:col-span-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-10 lg:sticky lg:top-32",
                                children: [
                                    isNotAPastEvent && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPanelInfo, {
                                        info: event.info
                                    }),
                                    hasGallery && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPhotoGallery, {
                                        event: event.title,
                                        uri: event.uri,
                                        gallery: event.gallery
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(56410); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);